module.exports = __webpack_public_path__ + "img/camera-grey.c47ce82b.svg";